export const WISHLIST_CONTENT = {
  title: 'My Wishlist',
  breadcrumb: 'My Wishlist',
  itemCount: (count: number) => `${count} item${count !== 1 ? 's' : ''} saved`,
  clearAll: 'Clear All',
  continueShopping: 'Continue Shopping',
  empty: {
    title: 'Your Wishlist is Empty',
    description: 'Save your favorite items here! Click the heart icon on any product.',
    button: 'Explore Products',
  },
  popularTitle: 'Popular Categories',
  popularCategories: [
    {
      name: 'Teddy Bears',
      path: '/shop?category=bears',
      image: '/1.png',
    },
    {
      name: 'Bunnies',
      path: '/shop?category=bunnies',
      image: '/2.png',
    },
    {
      name: 'Soft Dolls',
      path: '/shop?category=new',
      image: '/3.png',
    },
    {
      name: 'Keychains',
      path: '/shop?category=new',
      image: '/4.png',
    },
  ],
  footerNote: 'Items in your wishlist are not reserved until purchased.',
} as const;
